// import React from 'react';
// import { motion } from 'framer-motion';

// const Section1 = () => {
//   return (
//     <motion.div
//       initial={{ opacity: 0, y: -50 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.8, ease: 'easeOut' }}
//       viewport={{ once: true }}
//       style={{
//         textAlign: 'center',
//         padding: '60px 20px',
//         maxWidth: '900px',
//         margin: '0 auto',
//       }}
//     >
//       <div style={{ textAlign: 'center', margin: '30px 0' }}>
//         <h2
//           style={{
//             fontSize: '36px',
//             fontWeight: '800',
//             color: '#5DA840',
//             marginBottom: '10px',
//           }}
//         >
//           Why Choose Us?
//         </h2>

//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//           <div
//             style={{
//               width: '10px',
//               height: '10px',
//               borderRadius: '50%',
//               backgroundColor: 'white',
//               border: '2px solid #023E62',
//               margin: '0 10px',
//             }}
//           />
//           <div style={{ height: '2px', width: '60px', backgroundColor: '#023E62' }} />
//         </div>
//       </div>

//       <p style={{ fontSize: '18px', color: '#333', lineHeight: '1.8' }}>
//         At <strong style={{ color: '#00264F' }}>PDN & ASSOCIATES</strong>, we focus on simplifying
//         financial management and regulatory compliance so you can concentrate on growing your
//         business. Our experienced team of Chartered Accountants delivers customized solutions
//         tailored to individuals, startups, and well-established enterprises. We ensure clarity,
//         precision, and peace of mind in every financial step you take.
//       </p>

//       <button
//         style={{
//           marginTop: '40px',
//           backgroundColor: '#5DA840',
//           color: '#fff',
//           fontSize: '16px',
//           padding: '12px 28px',
//           border: 'none',
//           borderRadius: '999px',
//           cursor: 'pointer',
//           display: 'inline-flex',
//           alignItems: 'center',
//           gap: '8px',
//         }}
//       >
//         Read More <span style={{ fontSize: '18px' }}>➜</span>
//       </button>
//     </motion.div>
//   );
// };

// export default Section1;

















import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Button } from '@mui/material';

const Section1 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          textAlign: 'center',
          padding: { xs: '40px 16px', md: '60px 20px' },
          maxWidth: { xs: '100%', sm: '700px', md: '900px' },
          margin: '0 auto',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: { xs: '20px', md: '30px' } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '28px', md: '36px' },
              fontWeight: '800',
              color: '#5DA840',
              mb: '10px',
            }}
          >
            Why Choose Us?
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box
              sx={{
                height: '2px',
                width: { xs: '40px', md: '60px' },
                backgroundColor: '#023E62',
              }}
            />
            <Box
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: 'white',
                border: '2px solid #023E62',
                mx: '10px',
              }}
            />
            <Box
              sx={{
                height: '2px',
                width: { xs: '40px', md: '60px' },
                backgroundColor: '#023E62',
              }}
            />
          </Box>
        </Box>

        <Typography
          sx={{
            fontSize: { xs: '16px', md: '18px' },
            color: '#333',
            lineHeight: '1.8',
            px: { xs: 2, md: 0 },
          }}
        >
          At <strong style={{ color: '#00264F' }}>PDN & ASSOCIATES</strong>, we focus on simplifying
          financial management and regulatory compliance so you can concentrate on growing your
          business. Our experienced team of Chartered Accountants delivers customized solutions
          tailored to individuals, startups, and well-established enterprises. We ensure clarity,
          precision, and peace of mind in every financial step you take.
        </Typography>

        <Button
          sx={{
            mt: { xs: '24px', md: '40px' },
            backgroundColor: '#5DA840',
            color: '#fff',
            fontSize: { xs: '14px', md: '16px' },
            padding: { xs: '10px 20px', md: '12px 28px' },
            borderRadius: '999px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#4A8E33',
            },
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          Read More <span style={{ fontSize: { xs: '16px', md: '18px' } }}>➜</span>
        </Button>
      </Box>
    </motion.div>
  );
};

export default Section1;
